import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import {
	cloudinaryImageToSrcUrlAdapter,
	cloudinaryImageAdapter,
} from "../../../sharedComponents/CloudinaryImageAdapter";
// eslint-disable-next-line import/no-cycle
import { Link } from "../../../sharedComponents/Link";
// eslint-disable-next-line import/no-cycle
import {
	SecondaryCard,
	SenaryCard,
	PrimaryCard,
	TertiaryCard,
	QuaternaryCard,
	CruiseCard,
	BrandCard,
	HeroCard,
	HotelCardTopResults,
	BlogCard,
	SingleCard,
	CommonCard,
	NoBorderCard,
	SquareCard,
} from "../../Card";
// eslint-disable-next-line import/no-cycle
import { PromoCard } from "../../Cards";
import { Cell, Row } from "../../Grid/Grid";
// eslint-disable-next-line import/no-cycle
import { CardsContainerSlide } from "../../CardsContainer";
import { MobileDetector } from "../../MobileDetector";
import { Heading } from "../../Headings/Heading";

// eslint-disable-next-line import/no-cycle
import { FluidSections } from "../../FluidSections";
import * as heroStyles from "../../HeroSection/HeroSection.module.scss";
// eslint-disable-next-line import/no-cycle
import { StoreInfoConnector } from "../../StoreInfoCard";
import * as styles from "./TileCollection.module.scss";

// TODO:: Task 99842: CardCollection, Tile Slider and Paginated collection Update
const TileCollection = ({
	title,
	tiles,
	variant,
	largeTiles,
	mobileSlider,
	slidesPerPage,
	id,
	hideLinks,
	theme,
}) => {
	const deviceType = MobileDetector();

	let Card = SecondaryCard;
	let mobileSliderTrigger = false;

	const mobileBreakPoint = {
		320: {
			slidesPerView: 1.1,
			spaceBetween: 12,
		},
		576: {
			slidesPerView: 2,
			spaceBetween: 12,
		},
		768: {
			slidesPerView: 3,
			spaceBetween: 12,
		},
	};

	if (variant === "senary") {
		Card = SenaryCard;
	} else if (variant === "primary") {
		Card = PrimaryCard;
	} else if (variant === "tertiary") {
		Card = TertiaryCard;
	} else if (variant === "quaternary") {
		Card = QuaternaryCard;
	} else if (variant === "cruise") {
		Card = CruiseCard;
	} else if (variant === "brand") {
		Card = BrandCard;
	} else if (variant === "topHotel") {
		Card = HotelCardTopResults;
	} else if (variant === "hero") {
		Card = HeroCard;
	} else if (variant === "blog") {
		Card = BlogCard;
	} else if (variant === "single" || variant === "single-vcenter" || variant === "single-desc") {
		Card = SingleCard;
	} else if (variant === "noborder") {
		Card = NoBorderCard;
		mobileSliderTrigger = true;
	} else if (variant === "common") {
		Card = CommonCard;
	} else if (variant === "square") {
		Card = SquareCard;
	} else if (variant === "promo") {
		Card = PromoCard;
	} else {
		Card = SecondaryCard;
		mobileSliderTrigger = false;
	}

	if (deviceType === "Mobile" && mobileSliderTrigger && mobileSlider) {
		Card = NoBorderCard;
		return (
			<>
				{title && (
					<Heading as="h2" size="h1" center className="margin-bottom-lg">
						{title}
					</Heading>
				)}
				{tiles && (
					<CardsContainerSlide slidesPerPage={slidesPerPage} breakpoints={mobileBreakPoint} id={id}>
						{tiles.map(tile => (
							<Card
								key={tile.id}
								id={tile.id}
								header={tile.displayTitle}
								variant={tile.variant}
								subheader={tile.subTitle}
								subheader2={tile.subTitle2}
								headerClassName={heroStyles.header}
								color={tile.color}
								content={tile?.content?.childMarkdownRemark?.html}
								stars={tile?.stars}
								minAge={tile?.minAge}
								icon={tile?.icon}
								button={tile?.button}
								link={
									tile.link && {
										to: tile.link.url,
										target: tile.link.target,
										text: tile.link.linkText || tile.link.displayTitle || tile.title,
									}
								}
								image={{
									...cloudinaryImageAdapter({
										cloudinaryImage:
											tile?.cloudinaryImage?.[0] || tile?.sourceSet?.[0]?.cloudinaryAsset?.[0],
										maxWidth: 400,
										title: tile.displayTitle,
										desc: tile.displayTitle,
									}),
								}}
								linkIcon={{
									alt: tile.title,
									src: cloudinaryImageToSrcUrlAdapter(tile?.logo?.[0]),
								}}
								checklist={tile.checkListItems}
								primary
								renderLink={(link, { className, altText, children }) => (
									// eslint-disable-next-line react/jsx-props-no-spreading
									<Link to={link.to} className={className} title={altText} {...link}>
										{children}
									</Link>
								)}
							/>
						))}
					</CardsContainerSlide>
				)}
			</>
		);
	}
	return (
		<div
			className={cx(
				styles.tilesCollectionWrapper,
				{ largeTiles },
				{ mobileSlider },
				variant === "common" && "tilesCollectionWrapperCommon"
			)}>
			{title && (
				<Heading as="h2" size="h1" className={styles.tilesCollectionTitle}>
					{title}
				</Heading>
			)}
			{tiles && (
				<Row cols={slidesPerPage || (largeTiles ? 2 : 3)}>
					{variant === "storeInfo"
						? tiles.map(tile => (
								// eslint-disable-next-line react/jsx-indent
								<Cell key={tile.id}>
									<StoreInfoConnector store={tile} />
								</Cell>
						  ))
						: tiles.map(tile => (
								// eslint-disable-next-line react/jsx-indent
								<Cell key={tile.id}>
									<Card
										id={tile.id}
										className={styles.card}
										header={tile.displayTitle}
										variant={tile.variant}
										collectionVariant={variant}
										subheader={tile.subTitle}
										subheader2={tile.subTitle2}
										color={tile.color}
										content={tile?.content?.childMarkdownRemark?.html}
										stars={tile?.stars}
										minAge={tile?.minAge}
										icon={tile?.icon}
										button={tile?.button}
										hideLinks={hideLinks}
										tab={tile?.tab}
										modalContent={
											tile?.modalContent && (
												<FluidSections data={tile?.modalContent} useWrapper={false} />
											)
										}
										link={
											tile.link && {
												to: tile.link.url,
												target: tile.link.target,
												text: tile.link.linkText || tile.link.displayTitle || tile.title,
											}
										}
										image={
											tile?.cloudinaryImage?.[0] || tile?.sourceSet?.[0]?.cloudinaryAsset?.[0]
												? {
														...cloudinaryImageAdapter({
															cloudinaryImage:
																tile?.cloudinaryImage?.[0] ||
																tile?.sourceSet?.[0]?.cloudinaryAsset?.[0],
															maxWidth: 800,
															title: tile.displayTitle,
															desc: tile.displayTitle,
														}),
												  }
												: {
														src: tile?.image?.file?.url,
														alt: tile?.displayTitle,
												  }
										}
										logo={{
											alt: tile.title,
											src: cloudinaryImageToSrcUrlAdapter(tile?.logo?.[0]),
										}}
										checklist={tile.checkListItems}
										theme={theme}
										renderLink={(link, { className, altText, children }) => (
											// eslint-disable-next-line react/jsx-props-no-spreading
											<Link to={link.to} className={className} title={altText} {...link}>
												{children}
											</Link>
										)}
									/>
								</Cell>
						  ))}
				</Row>
			)}
		</div>
	);
};
TileCollection.propTypes = {
	title: PropTypes.string,
	id: PropTypes.string.isRequired,
	variant: PropTypes.string,
	largeTiles: PropTypes.bool,
	mobileSlider: PropTypes.bool,
	hideLinks: PropTypes.bool,
	tiles: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.string,
			title: PropTypes.string,
			link: PropTypes.shape({
				url: PropTypes.string,
				target: PropTypes.string,
			}),
			image: PropTypes.shape({
				file: PropTypes.shape({
					url: PropTypes.string,
				}),
			}),
			sourceSet: PropTypes.arrayOf(PropTypes.object),
			cloudinaryImage: PropTypes.arrayOf(PropTypes.object),
			logo: PropTypes.arrayOf(PropTypes.object),
			checkListItems: PropTypes.arrayOf(PropTypes.object),
		})
	),
	slidesPerPage: PropTypes.number,
	theme: PropTypes.string,
};

TileCollection.defaultProps = {
	title: null,
	variant: null,
	largeTiles: false,
	mobileSlider: false,
	tiles: [],
	slidesPerPage: null,
	hideLinks: false,
	theme: null,
};

export default TileCollection;
export { TileCollection };
